import { useState, useEffect } from 'react';

// Creates a URL from a fileObject.
// See https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
export const useCreateObjectURL = fileObject => {
  const [fileURL, setFileURL] = useState('');

  // This should be called after the fileURL has been loaded in the dom so that the object URL can be released from memory.
  // For an example of this, see: https://developer.mozilla.org/en-US/docs/Web/API/File/Using_files_from_web_applications#example_using_object_urls_to_display_images
  // See also https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL#memory_management
  const unLoadFileUrl = () => URL.revokeObjectURL(fileURL);

  useEffect(() => {
    if (fileObject) {
      setFileURL(URL.createObjectURL(fileObject));
    }

    return unLoadFileUrl;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileObject]);

  return {
    url: fileURL,
    onLoad: unLoadFileUrl,
  };
};
